import api from './api';

export const adminProductService = {
    getAll: (params) => api.get('/admin/products', { params }),
    getById: (id) => api.get(`/admin/products/${id}`),
    create: (data) => api.post('/admin/products', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
    update: (id, data) => api.post(`/admin/products/${id}`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
        params: { _method: 'PUT' } // Laravel spoofing for PUT with files
    }),
    delete: (id) => api.delete(`/admin/products/${id}`)
};
